import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React, { type FC } from 'react';

import type { YourCandidatesNode_CandidateRowFragment } from '../YourCandidates/YourCandidates.generated';

import translations from './.vocab';

interface MostRecentRoleMobileProps {
  mostRecentRoleTitle: YourCandidatesNode_CandidateRowFragment['lastRoleJobTitle'];
  mostRecentRoleCompanyName: YourCandidatesNode_CandidateRowFragment['lastRoleCompanyName'];
}

export const MostRecentRoleMobile: FC<MostRecentRoleMobileProps> = ({
  mostRecentRoleCompanyName,
  mostRecentRoleTitle,
}) => {
  const { t } = useTranslations(translations);

  if (!mostRecentRoleTitle) {
    return (
      <Text size="small" maxLines={1}>
        {t('New to workforce')}
      </Text>
    );
  }

  if (!mostRecentRoleCompanyName) {
    return (
      <Text size="small" maxLines={2}>
        {mostRecentRoleTitle}
      </Text>
    );
  }

  return (
    <Text size="small" maxLines={2}>
      {t('{mostRecentRoleTitle} at {mostRecentRoleCompanyName}', {
        mostRecentRoleCompanyName,
        mostRecentRoleTitle,
      })}
    </Text>
  );
};
